export default __webpack_public_path__ + "static/media/wuzileng.93dee985.jpg";